var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"Lab was succesfully created","width":"400px","visible":_vm.showLabAdded,"destroy-on-close":true},on:{"close":_vm.closeHandler}},[_c('div',[_vm._v("Lab "+_vm._s(_vm.labName)+" was created")])])}
var staticRenderFns = []

export { render, staticRenderFns }